import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import PageLayout from "../../Components/UI/PageLayout.js";

const AboutPage = () => {
  return (
    <PageLayout
      title="About"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "About" }]}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* About PCFA */}
        <Card sx={{ backgroundColor: "#2a3447" }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              About PCFA
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Welcome to the Pro Clubs Football Association management platform!
              PCFA is a comprehensive web-based solution designed to streamline
              league management, team organisation, and player performance
              tracking.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              PCFA provides everything you need to run a competitive football
              league: create and manage teams, track player statistics across
              seasons, organise matches, monitor league standings, and handle
              player transfers. Whether you're managing a casual league or a
              competitive championship, PCFA offers the tools to keep everything
              organised and accessible.
            </Typography>
            <Typography variant="body1">
              The platform includes a full suite of features: comprehensive team
              and player administration, detailed match tracking with appearance
              records, dynamic league tables and standings, multi-season support
              for long-term league management, and a transfer request system for
              player movement. User accounts support role-based access, including
              admin capabilities for league administrators.
            </Typography>
          </CardContent>
        </Card>

        {/* About the Developer */}
        <Card sx={{ backgroundColor: "#2a3447" }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              About the Developer
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              I'm Craig (Fearisor on Discord), a Software Engineer with over a
              decade of experience across diverse technologies. While Java is my
              primary focus, I've developed a passion for full-stack development,
              working across Java, Python, React, AWS, and Terraform. Over the
              years, I've delivered complex solutions for clients in the public
              sector and online gaming, with a strong emphasis on technical
              leadership and agile methodologies.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              PCFA is a personal project that combines my love for football and
              software engineering. It showcases my ability to design and build
              production-ready applications with modern technologies.
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Button
                variant="contained"
                startIcon={<LinkedInIcon />}
                href="https://www.linkedin.com/in/craig-wilson-35701865/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </Button>
              <Button
                variant="outlined"
                startIcon={<ForumRoundedIcon />}
                href="https://discord.gg/CSvEhYnYbF"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join Discord
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </PageLayout>
  );
};

export default AboutPage;
